module.exports = __webpack_public_path__ + "static/media/java-script.05dba317.svg";